(() => {
window.addEventListener("DOMContentLoaded", ()=>{
    const $searchButton = document.querySelector(".cmp-header__search-button");
    const $searchForm = document.querySelector(".cmp-header__search-form");
    const $closeButton = document.querySelector(".cmp-header__search-form .search-clear button");
    const $searchInput = document.querySelector(".cmp-header__search-form .search-field input");
    const $submitButton = document.querySelector(".cmp-header__search-form .suggestions button");
    const toggleSearchForm = ()=>{
        $searchButton?.classList.toggle("cmp-header__search-button--active");
        $searchForm?.classList.toggle("cmp-header__search-form--visible");
    };
    const toggleSearchSubmit = ()=>{
        $submitButton?.toggleAttribute("disabled", $searchInput?.value.trim() === "");
    };
    $searchButton?.addEventListener("click", ()=>{
        toggleSearchForm();
    });
    $closeButton?.addEventListener("click", ()=>{
        toggleSearchForm();
    });
    $searchInput?.addEventListener("input", ()=>{
        toggleSearchSubmit();
    });
    toggleSearchSubmit();
});


window.addEventListener("DOMContentLoaded", ()=>{
    const $menuButton = document.querySelector(".cmp-header__menu-button");
    const $menuNav = document.querySelector(".cmp-header__menu-nav");
    const $closeButton = document.querySelector(".cmp-header__menu-nav .cmp-header__menu-close-button");
    const $primaryNavLinks = document.querySelectorAll(".cmp-header__menu-nav-primary .cmp-navigation__item-link");
    const togglemenuNav = ()=>{
        $menuButton?.classList.toggle("cmp-header__menu-button--active");
        $menuNav?.classList.toggle("cmp-header__menu-nav--visible");
    };
    $menuButton?.addEventListener("click", ()=>{
        togglemenuNav();
    });
    $closeButton?.addEventListener("click", ()=>{
        togglemenuNav();
    });
    // Mega menu primary navigation
    Array.from($primaryNavLinks).forEach(($navLink)=>{
        $navLink.addEventListener("click", (e)=>{
            // User has pressed Ctrl/Cmd when clicking - return so link opens in new tab
            if (e.ctrlKey || e.metaKey) return true;
            const $parent = $navLink.closest(".cmp-navigation__item");
            if ($parent?.classList.contains("cmp-navigation__item--visible")) {
                $parent?.classList.remove("cmp-navigation__item--visible");
                return;
            }
            const levelClass = $parent ? Array.from($parent.classList.values()).find((x)=>x.includes("cmp-navigation__item--level-")) : "";
            // Remove visible class from other items in same level
            Array.from($primaryNavLinks).forEach(($navLink)=>{
                const $parent = $navLink.closest(".cmp-navigation__item");
                if ($parent && levelClass && $parent.classList.contains(levelClass)) $parent.classList.remove("cmp-navigation__item--visible");
            });
            // Show subnav
            $parent?.classList.add("cmp-navigation__item--visible");
            // Follow link if there is no subnav
            if ($parent?.querySelector(".cmp-navigation__group")) e.preventDefault();
        });
    });
});


window.addEventListener("DOMContentLoaded", ()=>{
    const $breadcrumb = document.querySelector(".cmp-header__navigation .breadcrumb");
    const menuHtml = $breadcrumb?.innerHTML;
    const $menu = document.createElement("div");
    $menu.innerHTML = menuHtml || "";
    $menu.classList.add("cmp-breadcrumb__menu");
    $breadcrumb?.appendChild($menu);
    $breadcrumb?.addEventListener("click", (e)=>{
        const $parentMenu = e.target?.closest(".cmp-breadcrumb__menu");
        if (!$parentMenu) $menu.classList.toggle("cmp-breadcrumb__menu--visible");
    });
    document.addEventListener("click", (e)=>{
        const $parentMenu = e.target?.closest(".cmp-breadcrumb__menu");
        const $parentButton = e.target?.closest(".cmp-header__navigation .breadcrumb");
        if (!$parentMenu && !$parentButton) $menu.classList.remove("cmp-breadcrumb__menu--visible");
    });
    document.addEventListener("keyup", (e)=>{
        if (e.key === "Escape") $menu.classList.remove("cmp-breadcrumb__menu--visible");
    });
});




window.addEventListener("DOMContentLoaded", ()=>{
    const $videoElements = document.querySelectorAll(".cmp-video");
    Array.from($videoElements).forEach(($element)=>{
        const $playButton = $element.querySelector(".cmp-video_play-button");
        const $videoImage = $element.querySelector(".cmp-video_image");
        const $video = $element.querySelector(".cmp-video_video");
        const $videoIframe = $element.querySelector(".cmp-video_video iframe");
        const $parentElement = $element.closest(".cmp-video-card");
        if ($playButton) $playButton.addEventListener("click", (e)=>{
            e.preventDefault();
            $videoImage?.classList.add("cmp-video_image--hidden");
            $video?.classList.remove("cmp-video_video--hidden");
            const videoId = $element.dataset["video_id"];
            $videoIframe?.setAttribute("src", `https://www.youtube.com/embed/${videoId}?autoplay=1`);
            // Notify parent that video has started playing if relevant (ie matches $parentElement selector)
            if ($parentElement) $parentElement.classList.add("video-playing");
        });
    });
});


class $e0df1631796d11ab$export$d64e5893a271cf04 {
    loadScript(scriptUrl) {
        return new Promise((resolve, reject)=>{
            const $script = document.createElement("script");
            $script.setAttribute("src", scriptUrl);
            $script.onload = ()=>resolve(true);
            $script.onerror = ()=>reject();
            document.head.appendChild($script);
        });
    }
}


window.addEventListener("DOMContentLoaded", async ()=>{
    const scriptLoader = new (0, $e0df1631796d11ab$export$d64e5893a271cf04)();
    const googleMapsApiUrl = "https://maps.googleapis.com/maps/api/js?key={key}";
    const mapIcon = {
        path: "M5.92666667,10.2866667 C5.92666667,7.97333333 7.74666667,6.09333333 10,6.09333333 C12.2533333,6.09333333 14.0733333,7.97333333 14.0733333,10.2866667 C14.0733333,12.6 12.2533333,14.4733333 10,14.4733333 C7.74666667,14.4733333 5.92666667,12.6 5.92666667,10.2866667 M0,10.2866667 C0,15.9666667 9.62666667,26.6666667 10,26.6666667 C10.3733333,26.6666667 20,15.9666667 20,10.2866667 C20,4.60666667 15.52,0 10,0 C4.48,0 0,4.60666667 0,10.2866667",
        fillColor: "#ffdc00",
        fillOpacity: 1,
        anchor: {
            x: 10,
            y: 27
        },
        strokeWeight: 0,
        scale: 1.5
    };
    const $mapElements = document.querySelectorAll(".cmp-google-map");
    if ($mapElements.length > 0) {
        // Get Google Maps API key from first map
        const apiKey = $mapElements.item(0).dataset["apiKey"];
        if (apiKey) {
            await scriptLoader.loadScript(googleMapsApiUrl.replace(/{key}/g, apiKey));
            Array.from($mapElements).forEach(($element)=>{
                const $mapElement = $element.querySelector(".cmp-google-map__map");
                if ($mapElement) {
                    const centre = $element.dataset["centre"];
                    const zoom = $element.dataset["zoom"];
                    const style = $element.dataset["style"];
                    const markerTitle = $element.dataset["markerTitle"];
                    if (centre && zoom) {
                        let mapStyle = null;
                        if (style && style.trim() !== "") try {
                            mapStyle = JSON.parse(style);
                        } catch (e) {
                            console.error(`[google-map] Exception parsing map styles:`);
                            console.error(e);
                        }
                        const coords = {
                            lat: parseFloat(centre.split(",")[1]),
                            lng: parseFloat(centre.split(",")[0])
                        };
                        const map = new google.maps.Map($mapElement, {
                            zoom: parseInt(zoom, 10),
                            center: coords,
                            styles: mapStyle,
                            controlSize: 24,
                            disableDefaultUI: true
                        });
                        const marker = new google.maps.Marker({
                            position: coords,
                            map: map,
                            icon: mapIcon,
                            title: markerTitle
                        });
                        if (markerTitle && markerTitle.trim() !== "") {
                            const markerWindow = new google.maps.InfoWindow({
                                content: `<div class="cmp-google-map__marker-title">${markerTitle}</div>`
                            });
                            marker.addListener("click", ()=>{
                                markerWindow.open({
                                    anchor: marker,
                                    map: map
                                });
                            });
                        }
                    }
                }
            });
        }
    }
});



class $e590ff2f2d312363$export$5c5505574f82c31d {
    loadStyle(styleUrl) {
        return new Promise((resolve, reject)=>{
            const $style = document.createElement("link");
            $style.setAttribute("rel", "stylesheet");
            $style.setAttribute("href", styleUrl);
            $style.onload = ()=>resolve(true);
            $style.onerror = ()=>reject();
            document.head.appendChild($style);
        });
    }
}


window.addEventListener("DOMContentLoaded", async ()=>{
    const scriptLoader = new (0, $e0df1631796d11ab$export$d64e5893a271cf04)();
    const styleLoader = new (0, $e590ff2f2d312363$export$5c5505574f82c31d)();
    const $mapElements = document.querySelectorAll(".cmp-maze-map");
    if ($mapElements.length > 0) {
        await scriptLoader.loadScript("https://api.mazemap.com/js/v2.0.106/mazemap.min.js");
        await styleLoader.loadStyle("https://api.mazemap.com/js/v2.0.106/mazemap.min.css");
    }
    Array.from($mapElements).forEach(($element)=>{
        const $mapElement = $element.querySelector(".cmp-maze-map__map");
        if ($mapElement) {
            const zoom = $element.dataset["zoom"];
            const level = $element.dataset["level"];
            const centre = $element.dataset["centre"];
            const campuses = $element.dataset["campuses"];
            if (centre && zoom) {
                const map = new window.Mazemap.Map({
                    container: $mapElement,
                    campuses: campuses,
                    center: {
                        lat: parseFloat(centre.split(",")[1]),
                        lng: parseFloat(centre.split(",")[0])
                    },
                    zoom: zoom,
                    zLevel: level
                });
                map.addControl(new window.Mazemap.mapboxgl.NavigationControl());
                map.scrollZoom.disable();
            }
        }
    });
});



})();
//# sourceMappingURL=base.a18f5949.js.map
